export default {
  isFreshAppOpen () {
    console.log('HERE')
    const sessionItewmName = 'appOpened'
    const alreadyTracked = sessionStorage.getItem(sessionItewmName)

    if (alreadyTracked) return false

    try {
      // Try the modern API
      const navEntry = performance.getEntriesByType('navigation')[0]

      if (navEntry && navEntry.type === 'navigate') {
        sessionStorage.setItem(sessionItewmName, 'true')
        return true
      }

      // Fallback for Safari or older browsers
      const legacyType = performance.navigation.type
      if (
        legacyType === performance.navigation.TYPE_NAVIGATE ||
        legacyType === 0
      ) {
        sessionStorage.setItem(sessionItewmName, 'true')
        return true
      }
    } catch (error) {
      console.error(error)
      return false
    }

    return false
  }
}



// WEBPACK FOOTER //
// ./scripts/src/helpers/browser.helper.js